/**
 *  Alaska: Editor
 *  Public: Risk Evaluator questionnare
 *
 *  @version 1.0
 */

document.addEventListener('alpine:init', () => {
    Alpine.data('RiskCalculatorForm', () => ({
        state: 'default',
        loading: false,

        form: {
            name: '',
            email: '',
        },

        errors: {
            name: '',
            email: '',
        },

        get isDefault() {
            return this.state === 'default' && !this.loading;
        },

        get loading_state() {
            return this.loading === true;
        },

        get isSuccess() {
            return this.state === 'success' && !this.loading;
        },

        validate() {
            let valid = true;

            if (this.form.name.trim() === '') {
                this.errors.name = 'Name is required';
                valid = false;
            } else {
                this.errors.name = '';
            }

            if (this.form.email.trim() === '') {
                this.errors.email = 'Email is required';
                valid = false;
            } else if (!this.form.email.includes('@')) {
                this.errors.email = 'Invalid email';
                valid = false;
            } else {
                this.errors.email = '';
            }

            return valid;
        },

        init() {
            const payload = Alpine.store('HtmlModal').payload; // pull the resultId injected via the modal payload
            this.resultId = payload?.resultId || null;
        },

        submit() {
            if (!this.validate()) {
                return;
            }

            this.loading = true;

            fetch('/alaska/public/', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    controller: 'Marketing',
                    action: 'updateRiskAssessmentLead',
                    data: {
                        ...this.form,
                        id: this.resultId,
                    },
                }),
            })
                .then((r) => r.json())
                .then((result) => {
                    this.loading = false;

                    if (result.type === 'success') {
                        this.state = 'success';

                        setTimeout(() => {
                            Alpine.store('HtmlModal').close();
                        }, 2500);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    console.error(err);
                });
        },
    }));
});
